export const AppNavHeight = 64;
export const UserMenuLinkHeight = 64;